// extracted by mini-css-extract-plugin
export var label = "_hh-2";
export var slideContainer = "_hh-0";
export var slider = "_hh-1";